<template>
  <div id="app">
    <router-view />
    <Footer />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import axios from 'axios'
import Footer from '@/components/Footer.vue'

// 配置axios
axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
  ? '' // 不再使用/api前缀，因为store中已经包含了
  : 'http://localhost:5000'

export default defineComponent({
  name: 'App',
  components: {
    Footer
  },
  mounted() {
    // 检查用户认证状态
    this.$store.dispatch('checkAuth')
  }
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-bottom: 120px; /* 增加底部内边距，确保内容不被固定页脚遮挡 */
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
